import { useTrans } from "@/translations";

import type React from "react";
import { useContext, useMemo } from "react";

import { twMerge } from "tailwind-merge";

import { TAB_LABELS } from "../constants";
import { ReportingPageContext } from "../context";
import { REPORTING_TAB_TYPES } from "../types";

type Props = {
  setTabType: (value: REPORTING_TAB_TYPES) => void;
};

export const ReportingTabView: React.FC<Props> = ({ setTabType }) => {
  const { t } = useTrans();
  const { viewType, tabType } = useContext(ReportingPageContext);

  const tabs = useMemo(
    () => [
      {
        id: REPORTING_TAB_TYPES.TOTAL,
        labelKey: TAB_LABELS[viewType][REPORTING_TAB_TYPES.TOTAL],
      },
      {
        id: REPORTING_TAB_TYPES.INDIVIDUAL,
        labelKey: TAB_LABELS[viewType][REPORTING_TAB_TYPES.INDIVIDUAL],
      },
    ],
    [viewType],
  );

  return (
    <div className="border-b-grey2 mt-[26px] mb-[-2px] flex items-end gap-[4px] border-b">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setTabType(tab.id)}
          className={twMerge(
            "font-dm-sans text-grey6 -mb-px inline-flex cursor-pointer items-center gap-[9px] border-0 border-b-[2.5px] border-solid border-b-transparent bg-transparent px-[16px] pt-[11px] pb-[13px] text-[14.5px] font-medium",
            tabType === tab.id && "border-b-[#1D1C1C] font-bold text-[#1D1C1C]",
          )}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
};
